// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconTransportPath = 'M8.342 2.941a.777.777 0 1 1 1.54-.22.777.777 0 0 1-1.54.22Zm-1.85.816-3.418.423a1 1 0 0 1-.246-1.985l3.732-.461a2.776 2.776 0 0 1 4.76-.588l3.627-.45a1 1 0 0 1 .246 1.986l-3.316.41c-.016.18-.05.355-.1.524l1.6.103a2 2 0 0 1 1.856 1.75l.96 7.765a3.49 3.49 0 0 1-2.81 3.856l.013.11a2.49 2.49 0 0 1-4.941.611l-.026-.207a4.168 4.168 0 0 1-1.089-.262l-.485 2.648-2.37-.01a1 1 0 1 1 .008-2l.696.003.361-1.97a4.176 4.176 0 0 1-.858-2.07L3.82 6.876A2 2 0 0 1 5.184 4.73l1.528-.499a2.756 2.756 0 0 1-.22-.474Zm1.558 10.78.121.978a2.196 2.196 0 0 1-1.494-1.817L5.804 6.63l1.93-.63a9 9 0 0 1 3.37-.424l2.144.138.96 7.764a1.49 1.49 0 0 1-1.072 1.616l-.144-1.168a2.49 2.49 0 1 0-4.942.61Zm2.411-.79a.49.49 0 0 0-.426.546l.405 3.273a.49.49 0 0 0 .971-.12l-.404-3.273a.49.49 0 0 0-.546-.426Zm1.257-7.004-4.18.517.245 1.985 4.18-.517-.245-1.985Z';
var IconTransport = baseIcon('IconTransport', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconTransportPath
});
export default IconTransport;
//# sourceMappingURL=index.js.map